// extracted by mini-css-extract-plugin
export var serviceList = "home-module--serviceList--JVQQC";